import { z } from "zod";

import { zConfig } from "./config";
import { EMPTY, SLASH } from "./str";

const ADMIN_PANEL = zConfig([z.string(), z.string()])
  .innerType()
  .shape.app.parse(import.meta.env).adminPanelRoute;

const ROUTES = {
  home: createPath([EMPTY]),
  adminPanel: {
    index: createRoute([], ADMIN_PANEL),
    dashboard: createRoute([ADMIN_PANEL], "dashboard"),
    orders: createRoute([ADMIN_PANEL], "orders"),
    services: createRoute([ADMIN_PANEL], "services"),
    serviceCategories: createRoute([ADMIN_PANEL], "service-categories"),
    users: createRoute([ADMIN_PANEL], "users"),
    inquiries: createRoute([ADMIN_PANEL], "inquiries"),
    reviews: createRoute([ADMIN_PANEL], "reviews"),
    documentation: createRoute([ADMIN_PANEL], "documentation"),
  },
  login: createPath(["login"]),
};

const zHomeSectionName = z.enum(["introduction", "services", "calculator", "reviews", "contacts"]);
const HomeSectionName = zHomeSectionName.Values;
type HomeSectionName = z.infer<typeof zHomeSectionName>;

function createPath(segments: string[]) {
  return [EMPTY, ...segments].join(SLASH);
}

function createRoute(parentSegments: string[], segment: string) {
  return {
    segment,
    path() {
      return createPath([...parentSegments, this.segment]);
    },
  };
}

function withLocale(path: string) {
  return ["/{-$locale}", path].join(EMPTY);
}

export { HomeSectionName, ROUTES, withLocale };
